export default __webpack_public_path__ + "static/media/gallery2.687b14c0.jpg";